import React from 'react'
import EditProfile from '../components/Author/EditProfile'
import AddUserDetails from '../components/User/UserInfo/AddUserDetails'
import EditUserDetails from '../components/User/UserInfo/EditUserDetails'

function EditProfilePage() {
    return (
        <div className="container my-4">
            <EditProfile />
            <hr />
            <h4>Legg til detaljer</h4>
            <AddUserDetails />
            <hr />
            <h4>Rediger detaljer</h4>
            <EditUserDetails />
        </div>
    )
}
export default EditProfilePage